<template>
  <div>
    <!-- 操作按钮 -->
    <a-row v-if="!disableSubmit" style="margin-bottom: 10px">
      <a-col :span="24">
        <a-button @click="addItem" type="primary" icon="plus">新增</a-button>
        <a-popconfirm v-if="items.length > 0" title="确定删除当前记录吗?" @confirm="deleteCurrentItem" style="margin-left: 10px">
          <a-button type="danger" icon="delete">删除当前</a-button>
        </a-popconfirm>
      </a-col>
    </a-row>

    <div v-if="items.length > 0" style="max-height: calc(100vh - 300px); overflow-y: auto; padding: 0 10px;">
      <div v-for="(item, idx) in items" v-show="idx === currentIndex" :key="item._key">
        <a-form layout="horizontal">
          <a-row :gutter="24">
            <a-col :md="12" :sm="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="质控措施">
                <a-select v-model="item.qcMeasure" placeholder="请选择" :disabled="disableSubmit"
                  @change="(val) => onMeasureChange(item, val)">
                  <a-select-option v-for="opt in filteredMeasureOptions" :key="opt.value" :value="opt.value">
                    {{ opt.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="核查因子">
                <a-select v-model="item.factorCode" placeholder="请选择" :disabled="disableSubmit"
                  @change="(val) => onFactorChange(item, val)">
                  <a-select-option v-for="f in factorOptions" :key="f.code" :value="f.code">
                    {{ f.name }}（{{ f.unit }}）
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :md="12" :sm="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="标气浓度">
                <a-input-number v-model="item.standardConcentration" :disabled="disableSubmit" style="width: 80%" />
                <span style="margin-left: 5px">{{ item.factorUnit }}</span>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="仪器量程">
                <a-input-number v-model="item.instrumentRange" :disabled="disableSubmit" style="width: 80%" @change="() => calcError(item)" />
                <span style="margin-left: 5px">{{ item.factorUnit }}</span>
              </a-form-item>
            </a-col>
          </a-row>

          <!-- 上次校准后测量 -->
          <a-row :gutter="24">
            <a-col :md="12" :sm="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上次校准后测量时间">
                <a-date-picker style="width: 100%" format="YYYY-MM-DD HH:mm" :show-time="{ format: 'HH:mm' }"
                  v-model="item.lastMeasureTime" :disabled="disableSubmit" @change="() => checkTimeInterval(item)" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上次校准后测量值">
                <a-input-number v-model="item.lastMeasuredValue" :disabled="disableSubmit" style="width: 80%"
                  @change="() => calcError(item)" />
                <span style="margin-left: 5px">{{ item.factorUnit }}</span>
              </a-form-item>
            </a-col>
          </a-row>

          <!-- 本次校准前前测量 -->
          <a-row :gutter="24">
            <a-col :md="12" :sm="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="本次校准前前测量时间">
                <a-date-picker style="width: 100%" format="YYYY-MM-DD HH:mm" :show-time="{ format: 'HH:mm' }"
                  v-model="item.currentMeasureTime" :disabled="disableSubmit" @change="() => checkTimeInterval(item)" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="本次校准前前测量值">
                <a-input-number v-model="item.currentMeasuredValue" :disabled="disableSubmit" style="width: 80%"
                  @change="() => calcError(item)" />
                <span style="margin-left: 5px">{{ item.factorUnit }}</span>
              </a-form-item>
            </a-col>
          </a-row>

          <!-- 时间间隔警告 -->
          <a-row v-if="item._timeWarning">
            <a-col :span="24">
              <a-alert type="warning" :message="item._timeWarning" show-icon />
            </a-col>
          </a-row>

          <!-- 误差 & 合格 -->
          <a-row :gutter="24">
            <a-col :md="12" :sm="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="绝对误差">
                <span>{{ item.absoluteError != null ? item.absoluteError : '--' }} {{ item.factorUnit }}</span>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="相对误差">
                <span>{{ item.relativeError != null ? item.relativeError + '%' : '--' }}</span>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :md="12" :sm="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否合格">
                <a-select v-model="item.qualified" :disabled="disableSubmit" placeholder="请选择">
                  <a-select-option value="yes">合格</a-select-option>
                  <a-select-option value="no">不合格</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :md="24">
              <a-form-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" label="备注">
                <a-textarea v-model="item.remark" :disabled="disableSubmit" placeholder="请输入备注" />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row style="margin-top: 5px">
            <a-col>

              <iws-upload :ref="'itemUpload_' + idx" :options="{ btnText: '上传附件' }" :disableSubmit="disableSubmit"
                filesrc="om_qc_st31_item" :srcid="item.id" />
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>

    <div v-else style="text-align: center; color: #999; padding: 80px 0;">暂无质控记录，请点击「新增」按钮添加</div>

    <div v-if="items.length > 0" style="text-align: center; padding: 10px 0;">
      <a-button :disabled="currentIndex <= 0" @click="currentIndex--" icon="left"></a-button>
      <span style="margin: 0 15px;">{{ currentIndex + 1 }} / {{ items.length }}</span>
      <a-button :disabled="currentIndex >= items.length - 1" @click="currentIndex++" icon="right"></a-button>
    </div>
  </div>
</template>

<script>
import { getAction, deleteAction } from '@/api/manage'
import { ajaxGetDictItems } from '@/api/api'
import IwsUpload from '@comp/upload/IwsUpload.vue'
import moment from 'moment'

export default {
  name: 'St31WeekForm',
  components: { IwsUpload },
  props: {
    disableSubmit: { type: Boolean, default: false },
    siteId: { type: [Number, String], default: null },
    st: { type: String, default: '31' },
    maintenanceType: { type: String, default: '' },
    pagePath: { type: String, default: '/om/qc/ledger' },
    dataItems: { type: Array, default: () => [] },
  },
  data() {
    return {
      items: [], currentIndex: 0, measureOptions: [], factorOptions: [],
      labelCol: { span: 8 }, wrapperCol: { span: 16 }, keyCounter: 0,
    }
  },
  computed: {
    filteredMeasureOptions() {
      return this.measureOptions.filter((i) => (i.depict || '').split(',').includes(this.maintenanceType))
    },
  },
  watch: {
    dataItems: { immediate: true, handler(val) {
      if (val && val.length > 0) {
        this.items = val.map((i) => {
          let mapped = { ...i, _key: 'k_' + this.keyCounter++, _timeWarning: '' }
          if (mapped.lastMeasureTime) mapped.lastMeasureTime = moment(mapped.lastMeasureTime)
          if (mapped.currentMeasureTime) mapped.currentMeasureTime = moment(mapped.currentMeasureTime)
          return mapped
        })
        this.currentIndex = 0
      }
    }},
    siteId(val) {
      if (val) this.loadDicts()
    },
  },
  mounted() {
    // 新增模式下自动添加第一条记录
    if (!this.disableSubmit && this.items.length === 0 && (!this.dataItems || this.dataItems.length === 0)) {
      this.addItem()
    }
  },
  created() { this.loadDicts() },
  methods: {
    loadDicts() {
      ajaxGetDictItems('qc_measure_st31').then((res) => { if (res.success) this.measureOptions = res.result || [] })
      if (!this.siteId) return
      Promise.all([
        getAction(this.pagePath + '/factorWhitelist', { st: '31', qcMeasure: 'zero_drift' }),
        getAction('/site/info/factor/find/' + this.siteId)
      ]).then(([resWhite, resSite]) => {
        if (resWhite.success && resWhite.result) {
          let siteFactors = (resSite.success && resSite.result) ? resSite.result : []
          let options = []
          resWhite.result.forEach((code) => {
            let f = siteFactors.find((sf) => sf.code === code)
            if (f) options.push({ code: code, name: f.title, unit: f.unitName || '' })
          })
          this.factorOptions = options
        }
      })
    },
    addItem() {
      this.items.push({
        _key: 'k_' + this.keyCounter++, _timeWarning: '', id: null,
        qcMeasure: undefined, factorCode: undefined, factorName: '', factorUnit: '',
        standardConcentration: null, instrumentRange: null,
        lastMeasureTime: null, lastMeasuredValue: null,
        currentMeasureTime: null, currentMeasuredValue: null,
        absoluteError: null, relativeError: null, qualified: undefined, remark: '',
      })
      this.currentIndex = this.items.length - 1
    },
    deleteCurrentItem() {
      let item = this.items[this.currentIndex]
      if (item.id) deleteAction(this.pagePath + '/item', { id: item.id, st: '31' })
      this.items.splice(this.currentIndex, 1)
      if (this.currentIndex >= this.items.length) this.currentIndex = Math.max(0, this.items.length - 1)
    },
    onMeasureChange(item, val) {
      item.qcMeasure = val
      item.factorCode = undefined; item.factorName = ''; item.factorUnit = ''
      item.absoluteError = null; item.relativeError = null
    },
    onFactorChange(item, code) {
      let f = this.factorOptions.find((i) => i.code === code)
      if (f) { item.factorCode = f.code; item.factorName = f.name; item.factorUnit = f.unit }
    },
    /** ST31漂移：绝对误差 = 校准前 - 校准后, 相对误差 = 绝对 / 仪器量程 */
    calcError(item) {
      if (item.currentMeasuredValue != null && item.lastMeasuredValue != null) {
        item.absoluteError = this.fixFloat(item.currentMeasuredValue - item.lastMeasuredValue)
      } else { item.absoluteError = null }
      if (item.absoluteError != null && item.instrumentRange && item.instrumentRange !== 0) {
        item.relativeError = Math.trunc(this.fixFloat((item.absoluteError / item.instrumentRange) * 100) * 100) / 100
      } else { item.relativeError = null }
    },
    fixFloat(val) { return val == null ? null : parseFloat(val.toFixed(6)) },
    /** 时间间隔校验 ≤7天 */
    checkTimeInterval(item) {
      if (item.lastMeasureTime && item.currentMeasureTime) {
        let diff = moment(item.currentMeasureTime).diff(moment(item.lastMeasureTime), 'days')
        item._timeWarning = diff > 7 ? `两次校准时间间隔为 ${diff} 天，超过7天限制` : ''
      }
    },
    collectData() {
      if (this.items.length === 0) { this.$message.warning('请至少添加一条质控记录'); return null }
      for (let i = 0; i < this.items.length; i++) {
        let item = this.items[i]
        if (!item.qcMeasure) { this.$message.warning(`第 ${i+1} 条未选择质控措施`); this.currentIndex = i; return null }
        if (!item.factorCode) { this.$message.warning(`第 ${i+1} 条未选择核查因子`); this.currentIndex = i; return null }
        if (item._timeWarning) { this.$message.warning(`第 ${i+1} 条：${item._timeWarning}`); this.currentIndex = i; return null }
        let ref = this.$refs['itemUpload_' + i]
        if (ref && ref[0]) {
          let fd = ref[0].getUploadList ? ref[0].getUploadList() : {}
          item.sysFileList = fd.sysFileList || []; item.fileDelList = fd.fileDelList || []
        }
      }
      return this.items.map(({ _key, _timeWarning, ...d }) => d)
    },
  },
}
</script>
